export default "__VITE_ASSET__Ct456B6A__"